import React from 'react';

import NotFoundImg from '@wineway/assets/images/page-not-found.svg';

function NotFoundPage() {
  return <img src={NotFoundImg} alt="404" />;
}

export default NotFoundPage;
